define(['app', './base', 'jquery'], function (app, Helper, $) {
  return Helper.extend({
    ui: {
      edit: '.js-edit',
      cancel: '.js-cancel',
      editor: '.js-content--editable > .editor',
      edit_box: '.js-content--editable',
      content: '.js-content--original'
    },

    triggers: {
      'click @ui.edit': 'edit',
      'click @ui.cancel': 'cancel:edit',
      'submit @ui.editor': 'submit:edit'
    },

    onCancelEdit: function () {
      this.ui.content.show()
      this.ui.edit_box.html('')
    },

    renderHtmlEditor: function (topicId, postId, data, isFirstPost) {
      this.ui.content.hide()
      window.insided.initialiseComponent(
        'editor/postEditor',
        this.ui.edit_box[0],
        {
          data: data,
          btnPhrase: 'Save',
          postId: postId,
          topicId: isFirstPost ? topicId : null,
          isControl: false,
          onSuccess: function () {
            window.location = window.location.pathname + '?postid=' + postId
          },
          onCancel: function () {
            this.onCancelEdit()
          }.bind(this)
        }
      )
    },

    onEdit: function () {
      var self = this
      var isFirstPost = self.el.classList.contains('js-toggle-target')
      var postId = self.ui.edit.data('postid')
      $.get('/post/getContent', { postid: postId }).then(data => {
        self.renderHtmlEditor(self.options.topicId, postId, data.content, isFirstPost)
      })
    }
  })
})
